import "./advice.scss";

export default function Advice() {

    window.scrollTo(0, 0);

    return (
        <div className="advice">
            <header>
                <div className="container">
                    <h1 className="general_title">
                        <pre>Советы {"\n"}новичкам</pre>
                    </h1>

                    <h2 className="">
                        МЫ НЕ РАССУЖДАЕМ О ВОЗМОЖНОСТЯХ
                        <br />
                        ИНВЕСТИРОВАНИЯ, МЫ ВОЛОЩАЕМ ИХ
                    </h2>
                </div>
            </header>

            <main>
                <div className="container">
                    <ol>
                        <li>
                            <strong>
                                Примите возможность утраты своих средств как неизбежный факт.
                            </strong>
                            Каждый начинающий трейдер должен понимать, что от проигрышей на
                            валютном рынке никто не застрахован. Основное правило в торговле
                            валютой состоит в том, чтобы прибыль была на много больше убытков.
                        </li>
                        <li>
                            <strong>
                                {" "}
                                Участвуйте в торгах только с четко определенным планом.
                            </strong>{" "}
                            Приступая к торгам, необходимо определить, каким количеством
                            собственных денежных средств Вы готовы рискнуть и на какую прибыль
                            Вы рассчитываете. Это будет Ваше соотношение риска и прибыльности.
                            Успешные трейдеры никогда не вступают в торги без четкого
                            понимания своей цели.
                        </li>
                        <li>
                            <strong>Не стоит опасаться валютного рынка.</strong> Многие
                            новички испытывают лишние опасения по поводу неопределенности и
                            рисков, присутствующих на рынке Форекс. Тому, кто сможет
                            преодолеть себя и вникнуть во все советы трейдеров, Форекс
                            действительно дает неограниченные возможности в плане увеличения
                            своего капитала.
                        </li>
                        <li>
                            <strong>
                                Ответственность за принятые решения.Ответственность за принятые
                                решения.
                            </strong>
                            Успешные трейдеры никогда не отказываются от собственной
                            ответственности. Можно принимать во внимание любые советы опытных
                            трейдеров, но вся ответственность за проведённые операции,
                            независимо от их результата, будет лежать только на Вас.
                        </li>
                        <li>
                            <strong>Ответственность за принятые решения.</strong> Успешные
                            трейдеры никогда не отказываются от собственной ответственности.
                            Можно принимать во внимание любые советы опытных трейдеров, но вся
                            ответственность за проведённые операции, независимо от их
                            результата, будет лежать только на Вас.
                        </li>
                        <li>
                            <strong>Не позволяйте алчности преодолеть Вас.</strong>
                            Когда торги начинают складываться успешно, трейдеры часто забывают
                            о ранее поставленных целях в надежде на дальнейшее удачное
                            продолжение своей торговли. Однако рынок очень изменчив и тренды
                            могут быстро заканчиваться. Как только будет достигнута целевая
                            цена, сразу снимайте прибыль или переводите сделку в
                            безубыточность.
                        </li>
                        <li>
                            <strong>Отключите эмоции.</strong> Причина ущерба часто
                            заключается в чрезмерной эмоциональности и нежелании слушать
                            советы. Форекс требует полного отключения эмоций при совершении
                            сделок. Непреклонно соблюдайте поставленный план и не забывайте
                            ставить "стопы".
                        </li>
                        <li>
                            <strong>Тренд Ваш друг.</strong> Торгуйте по направлению тренда –
                            и Ваша прибыль будет расти.
                        </li>
                    </ol>

                    <h2>Еще Несколько советов перед непосредственным началом</h2>

                    <ol>
                        <li>
                            <strong> Не торопитесь.</strong> Начинающие торговцы часто
                            открывают несколько торгов, а затем замечают, что не в состоянии
                            следить за ними. На Форекс можно получить прибыль как при подъеме,
                            так и при падении валютного курса. Удачно зарабатывать можно
                            только на одной паре валют. Поэтому сосредоточьтесь сначала на
                            одной валютной паре, а другие усваивайте постепенно.
                        </li>
                        <li>
                            <strong>Помните о стоп-приказе.</strong> Частая причина ущерба –
                            неправильный мани-менеджмент. Для предостережения большого ущерба
                            обязательно пользуйтесь стоп-приказом.
                        </li>
                        <li>
                            <strong>Торговая система.</strong> У каждого трейдера есть своя
                            торговая система, которую он адаптирует специально для себя. Одни
                            трейдеры предпочитают систему дневных торгов, другие привлекают
                            более долгие периоды. Главное – не отклоняться от намеченного
                            плана ведения торгов и обращать внимание на советы более опытных
                            трейдеров. Несколько неудачных операций не всегда свидетельствуют
                            об убыточности вашей торговой стратегии.
                        </li>
                        <li>
                            <strong>Фиксирование прибыли.</strong> Распространенная ошибка
                            начинающих трейдеров - раннее закрытие прибыльных позиций. Не
                            уклоняйтесь от намеченного торгового плана. Это позволит Вам не
                            потерять потенциальную прибыль.
                        </li>
                        <li>
                            <strong>Не превращайте прибыльные позиции в убыточные.</strong>
                            Внимательно наблюдайте за движением рынка. Как только будут
                            достигнуты положительные значения, установите стоп на уровне входа
                            в рынок. Это позволит защитить вложенные денежные средства. Затем
                            двигайте стоп за трендом, чтобы позиции оставались для Вас в
                            плюсе.
                        </li>
                        <li>
                            <strong>Частые входы.</strong> В частых входах на рынок нет ничего
                            плохого, однако если использовать их неумело, то не помогут
                            никакие советы, и такая торговля приведет Вас к банкротству. Суть
                            стратегии в том, что трейдер при убыточности позиции увеличивает
                            ее размер дополнительными операциями, предполагая, что рынок
                            вернется в прежнее состояние и все ордера будут закрыты с
                            прибылью. Однако, если валютный курс отойдет далеко от предыдущего
                            уровня, то ущерб будет еще более ощутимым. Так что лучше просто
                            покупать и держать одну операцию, чем пробовать отыграть вложенные
                            средства.
                        </li>
                        <li>
                            <strong>
                                Моментум и тренд. Начинающие торговцы часто даже не подозревают,
                                что с появлением новой тенденции растет моментум. Снова
                                присоединяющиеся трейдеры создают сильный импульс, когда по мере
                                роста тренда увеличивают общую массу открытых ордеров на рынке.
                                Торгуйте тогда, когда показатели момента работают в Вашу пользу.
                                При правильном подходе он будет подталкивать Ваши торги в нужном
                                направлении и Вы добьетесь фиксации прибыли даже скорее, чем
                                предполагали.
                            </strong>
                        </li>
                    </ol>

                    <p>
                        Следуя указанным советам от опытных трейдеров Форекс, Вы быстро
                        увидите улучшение результатов своей работы на валютном рынке. Теперь
                        Вы можете уверенно приступать к реальной торговле, открыв счет
                        Форекс.
                    </p>
                </div>
            </main>
        </div>
    );
}
